import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable()
export class RedirectGuard implements CanActivate {

    constructor(private router: Router) { }

    canActivate(activatedRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        window.location.href = environment.parentAppBaseUrl + activatedRoute.data['externalUrl'];
        return true;
    }
}
